const PARAMS = {
  PAGE_NAME: 'page_name',
  ELEMENT: 'element_name',
  MODAL_TYPE: 'modal',
  MODAL_NAME: 'modal_name',
};

export default PARAMS;
